import i18next from 'i18next';

export function getCurrencyName(currency: string) {
  return i18next.t(`global.currencies.${currency}.label`);
}
